<label class="label" [attr.for]="id + '__input'">
  <div *ngIf="(dragover$ | async) === true" class="dragover">Déposer votre document ici</div>

  <ng-container *ngIf="(dragover$ | async) === false">
    <button class="label__cta btn-clean" type="button" (click)="fileInputRef.click()">
      <ng-container *ngIf="caption">{{ caption }}</ng-container>
      <ng-container *ngIf="!caption">Déposez votre fichier ici</ng-container>
    </button>

    <span *ngIf="accept && maxSize" class="label__hint">
      fichier {{ accept | fileType: ' / ' }}&nbsp;-&nbsp;{{ maxSize }}Mo max
    </span>

    <span *ngIf="accept && !maxSize" class="label__hint"> Fichier {{ accept | fileType: ' / ' }} </span>

    <div *ngIf="!accept && maxSize" class="label__hint">
      <span class="label__hint--error" *ngIf="maxSizeExcedded; else defaultState"
        >Taille maximale dépassée. La taille maximale est&nbsp;: {{ maxSize }} MB.</span
      >
      <ng-template #defaultState class="label__hint"
        >Taille de fichier maximale pour le téléversement&nbsp;: {{ maxSize }} MB.</ng-template
      >
    </div>
  </ng-container>
</label>

<input
  tabindex="-1"
  [attr.id]="id + '__input'"
  class="file-input"
  type="file"
  [accept]="computedAccept"
  (change)="onFileInput($event)"
  #fileInputRef
/>
